import axios from "@/plugins/axios";

export default {
  getAiPromptByName(name) {
    return axios.get(`/ai_prompts/${name}`);
  },
  updateAiPrompts(name, prompt, response) {
    return axios.put(`/ai_prompts/${name}`, { prompt, response });
  },
};
